import { inject, Injectable } from '@angular/core';

import { FEATURE_FLAG } from './feature-flag.model';
import { FEATURE_FLAGS } from './feature-flags.config';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private readonly flags = inject(FEATURE_FLAGS);

  public enabled(flag: FEATURE_FLAG): boolean {
    return this.flags[flag];
  }
}
